import { Typography } from "@sgi/gravity/Typography";

export default function ButtonLink(props: any) {
  return (
    <button
      data-testid={props?.testid}
      type="button"
      onClick={props.handleClick}
    >
      <Typography variant="bodyBold" type="link" textDecoration="underline">
        {props.linkCaption}
      </Typography>
    </button>
  );
}
